

























































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppTextField extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: '289' }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: String, default: 'text' }) readonly type!: string;
  @Prop({ type: String }) readonly confirm!: string;
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String }) readonly hint!: string;
  @Prop({ type: String }) readonly prefix!: string;
  @Prop({ type: String }) readonly suffix!: string;
  @Prop({ type: String }) readonly prefixOut!: string;
  @Prop({ type: String }) readonly suffixOut!: string;

  model = '';

  showPWD = false;

  validRules = [];

  rules = {
    required: (value: string) => !!value || '不能为空！',
    text: () => true,
    email: (value: string) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const res = pattern.test(value)
      return res || '无效邮箱！'
    },
    cellphone: (value: string) => {
      const pattern = /^([1][3,4,5,6,7,8,9])\d{9}$/
      return pattern.test(value) || '无效手机号！'
    },
    password: (value: string) =>
      value === '' ||
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d\s])[A-Za-z\d\S]{8,20}$/.test(value) ||
      '密码至少8位，需包含数字、大小写字母和符号',
    confirm: (value: string) =>
      value === this.confirm || '密码两次输入结果不一致',
    number: (value: string) => {
      return !isNaN(Number(value)) || '只能输入数字'
    },
    currency: (value: string) => {
      return (
        /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) ||
        '只能输入小数点后两位以下的数字'
      )
    },
    percent: (value: string) => {
      return (
        /^([0-9]|[1-9][0-9])$|100/.test(value) ||
        '整数百分比'
      )
    },
    dateymd: (val: string) => {
      if (val) {
        return /^(\d{4})-(\d{2})-(\d{2})$/.test(val) || '请输入正确的日期格式如：2010-10-10'
      } else {
        return true
      }
    }
  };

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    return this.$R.trim(val)
  }

  @Watch('value')
  onValueChanged (val: string) {
    this.model = this.$R.trim(val)
  }
}
